module.exports = __webpack_public_path__ + "static/media/cancel_512.1e5456af.png";